<template>
	<div>
		<div class="d-flex align-center">
			<div class="pl-3" v-if="type == 'announcement'">
				<div class="font-12 primary--text accent lighten-1 px-3 py-1 rounded-pill font-weight-bold">
					<v-icon v-if="pinned" style="transform: rotate(40deg)" small color="primary" class="mr-1">mdi-pin-outline</v-icon>
					<template v-if="routeIsGroup">{{$vuetify.lang.t('$vuetify.views.wall.announcement.announcement')}}</template>
					<template v-else>{{$vuetify.lang.t('$vuetify.views.wall.announcement.companyAnnouncement')}}</template>
				</div>
			</div>
			<template v-if="type == 'problem' && problem && !simple">
				<problem-status-dropdown
					v-if="post.user.id == user.id"
					:post="post"
					:status="problem.status"/>
				<div v-else class="status" :class="problemStatus.class">
					{{ $vuetify.lang.t(problemStatus.title) }}
				</div>
			</template>
			<div v-if="!simple">
				<post-dropdown :options="validOptions" :loading="saving" />
			</div>
			<div v-else>
				<v-btn :to="'/post/' + post.id" elevation="0">{{ $vuetify.lang.t('$vuetify.views.wall.post.goTo') }}</v-btn>
			</div>
		</div>
		<post-delete-dialog :post="post" v-if="showDelete && !simple" @closed="showDelete = false" @deleted="postDeleted" />
		<post-dialog
			v-if="showEdit && !simple"
			ref="editPost"
			:groupId="groupId"
			@postEdited="postEdited"
			:type="type"
			:post="post"
			@closed="showEdit = false"
			edit/>
		<report-abuse-dialog :post="post" v-if="showReportAbuse" @closed="(showReportAbuse = false)" />
	</div>
</template>

<script>
import PostDropdown from "@/components/wall/post/PostDropdown";
import ProblemStatusDropdown from "@/components/wall/post/problem/ProblemStatusDropdown"
const PostDeleteDialog = import("@/components/wall/dialogs/PostDeleteDialog");
const PostDialog = import("@/components/wall/dialogs/PostDialog");
const ReportAbuseDialog = import("@/components/wall/dialogs/ReportAbuseDialog");
import {mapGetters} from 'vuex';
export default {
	name: "PostTopRight",
	components: {
		PostDropdown,
		ProblemStatusDropdown,
		PostDeleteDialog: () => ({
			component: PostDeleteDialog,
		}),
		PostDialog: () => ({
			component: PostDialog,
		}),
		ReportAbuseDialog: () => ({
			component: ReportAbuseDialog,
		}),

	},
	props: {
		routeIsGroup: {
			type: Boolean,
			required: false,
			default: false
		},
		pinned: {
			type: Boolean,
			required: true
		},
		post: {
			type: Object,
			required: true
		},
		type: {
			type: String
		},
		groupId: {
			type: Number
		},
		simple: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			// new, analyzed, in_progress, or resolved.
			saving: false,
			showReportAbuse: false,
			showEdit: false,
			showDelete: false,
			options: [
				{
					type: 'delete-post',
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.actions.delete'),
					icon: '$delete',
					action: () => {
						this.showDelete = true;
					}
				},
				{
					type: 'edit-post',
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.actions.edit'),
					icon: '$edit-input',
					action: () => this.editPost()
				},
				{
					type: 'comments-off',
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.actions.commentsOff'),
					icon: '$message-off',
					action: () => this.updateCommenting(true)
				},
				{
					type: 'comments-on',
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.actions.commentsOn'),
					icon: '$message',
					action: () => this.updateCommenting(false)
				},
				{
					type: 'notifications-off',
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.actions.notificationsOff'),
					icon: '$notification-off',
					action: this.action
				},
				{
					type: 'report-abuse',
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.actions.reportAbuse'),
					icon: '$exclamation',
					action: () => {
						this.showReportAbuse = true;
					}
				},
				{
					type: 'save',
					value: 0,
					text: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.save'),
					icon: '$download',
					action: async () => {
						this.saving = true;
						let res = await this.$store.dispatch('wall/saveForLater', {
							saveable_id: this.post.id,
							saveable_type: 'post'
						});
						if(res.success) {
							this.$snackbar.success('Pomyślnie zapisano post');
							this.$store.dispatch('wall/getSavedForLater');
						}
						else {
							console.log("ERROR", res.error)
							this.$snackbar.error({error: res.error, message: 'Nie możesz zapisać tego postu'})
						}
						this.saving = false;
					}

					/*
						{
						type: 'save',
						icon: '$download',
						text: this.$vuetify.lang.t('$vuetify.views.wall.post.buttons.save'),
						active: false,
						action: async () => {
							this.saving = true;
							let res = await this.$store.dispatch('wall/saveForLater', {
								saveable_id: this.post.id,
								saveable_type: 'post'
							});
							if(res.success) {
								this.$snackbar.success('Pomyślnie zapisano post');
								this.$store.dispatch('wall/getSavedForLater');
							}
							else {
								console.log("ERROR", res.error)
								this.$snackbar.error({error: res.error, message: 'Nie możesz zapisać tego postu'})
							}
							this.saving = false;
						}
					},
					*/
				}
			]
		}
	},
	computed: {
		...mapGetters({
			user: 'auth/user',
			problemStatuses: 'dictionaries/problemStatuses'
		}),
		problemStatus() {
			if(this.problem) {
				return this.problemStatuses.find(x => x.name == this.problem.status)
			}
			return null;
		},
		problem() {
			if(this.type == 'problem') {
				return this.post.postable;
			}
			return null;
		},
		validOptions() {
			let arr = [];
			this.options.forEach((x) => {
				if(this.user.id == this.post.user.id) {
					if(x.type == 'delete-post' || x.type == 'edit-post') {
						arr.push(x);
					}
					if(x.type == 'comments-off' && !this.post.is_comments_disabled) {
						arr.push(x);
					}
					if(x.type == 'comments-on' && this.post.is_comments_disabled) {
						arr.push(x);
					}
				}
				else {
					if(x.type == 'report-abuse' && !this.post.deleted_by_user_at) {
						arr.push(x);
					}
				}
				if(x.type == 'save') {
					arr.push(x);
				}

			});
			return arr;
		},
	},
	methods: {
		postDeleted() {
			this.$emit('deleted');
		},
		async updateCommenting(newVal) {
			let res = await this.$store.dispatch('wall/editPost', {
				post: {
					is_comments_disabled: newVal,
				},
				type: this.type,
				id: this.post.id
			});
			if(res.success) {
				if(newVal) {
					this.$snackbar.success("Wyłączono możliwość komentowania")
				}
				else {
					this.$snackbar.success("Włączono możliwość komentowania")
				}
			}
			else {
				this.$snackbar.error({error: res.error})
			}
		},
		editPost() {
			this.showEdit = true;
			this.$nextTick(function() {
				setTimeout(() => {
					if(this.$refs.editPost) this.$refs.editPost.showDialog();
				}, 100)

			})
		},
		postEdited() {
			//
		}
	}
}
</script>

<style lang="scss" scoped>


</style>
